import ExploreIcon from "assets/icons/ExploreIcon";

import styles from "./style.module.scss";

const ThankYouPage = () => {
  const handleDocsClick = () => {
    window.open("https://docs.visual-layer.com", "_blank");
  };

  return (
    <div className={styles.submittedSection}>
      <div className={styles.submittedHeader}>
        <div className={styles.submittedTitle}>Thanks for Your Details!</div>
        <div className={styles.submittedDescription}>
          We'll contact you soon to schedule your walkthrough with our team.
        </div>
      </div>

      <div className={styles.submittedContent}>
        <div className={styles.submittedQuestion}>Have questions?</div>
        <div className={styles.submittedAnswer}>
          Reach us at{" "}
          <a
            className={styles.supportLink}
            href="mailto:support@visual-layer.com"
            target="_blank"
            rel="noreferrer"
          >
            support@visual-layer.com.
          </a>
        </div>

        <div className={styles.getStartedText}>
          Looking forward to helping you get started!
        </div>

        <div className={styles.exploreDocsContainer} onClick={handleDocsClick}>
          <div className={styles.exploreDocsIcon}>
            <ExploreIcon />
          </div>
          <span className={styles.link}>Explore Our Introduction Docs</span>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
